var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelect = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19312"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19311"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13112"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 7794"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.655 13.004 15.357 6",
  "data-name": "Line 336"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5 9.688 3.608 3.261",
  "data-name": "Line 337"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z",
  "data-name": "Rectangle 7528"
})))));
export { SvgSelect as ReactComponent };
export default __webpack_public_path__ + "static/media/select.4347d4e1f45639559b0c1cc9db56bcdb.svg";